// extracted by mini-css-extract-plugin
module.exports = {"toggle":"toggle_toggle__2e9BS","slider":"toggle_slider__2o7jj","disabled":"toggle_disabled__37aH6","inverse":"toggle_inverse__2_ntO"};